import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../user-service/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router, 
    private userService: UserService) {}

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    
    if (err.status === 401) {
      this.router.navigateByUrl(`/login`);
      // if you've caught / handled the error, you don't want to rethrow it
      // return of(err.message); // or EMPTY may be appropriate here
      return EMPTY;
    }
    return throwError(err);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {      
      
    // Clone the request to add the new header.    
    const authReq = req.clone({
      setHeaders: {
        'Authorization': 'Bearer ' + this.userService.getToken()
      }
    });
    
    // catch the error, make specific functions for catching specific errors 
    // and you can chain through them with more catch operators
    return next
      .handle(authReq)
      .pipe(catchError((x) => this.handleAuthError(x)));
  }
}
